import requestAction from '../../utils/requestAction'
import Person from '../../models/Person';

export const upsertPerson = (person: (Person)) =>
  requestAction('PERSON_UPSERT')(
    `people${(person as Person).id ? `/${(person as Person).id}` : ''}`,
    (person as Person).id ? 'PUT' : 'POST',
    person
  )
